import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';

import { environment } from '@env/environment';
import { LocalStorageService } from '@services/storage/local-storage.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const localStorage: LocalStorageService = inject(LocalStorageService);
    const token: string = localStorage.get('token') ?? '';
    const requestUrl: string[] = request.url.split('/');
    let authRequest = request;
    if (token && this.isInternalApi(requestUrl[2])) {
      authRequest = request.clone({ setHeaders: { token: token } });
    }

    return next
      .handle(authRequest)
      .pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(
    err: HttpErrorResponse
  ): Observable<HttpEvent<unknown>> {
    const notLoginError = !err.error?.code?.includes('AUT');
    if (err.status === HttpStatusCode.Unauthorized && notLoginError) {
      localStorage.clear();
      this.router.navigate(['/login.html']);
      return EMPTY;
    }
    return throwError(() => err);
  }

  isInternalApi(url: string): boolean {
    const apiUrl: string[] = environment.endpoint.api.split('/');
    return apiUrl[2] === url;
  }
}
